import { inject, Injectable } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { OrganizationsStore } from '@cf/temp/services';

@Injectable({
  providedIn: 'root',
})
export class OrgRouterHelperService {
  #orgStore = inject(OrganizationsStore);
  #router = inject(Router);

  navigate(commands: any[], extras?: NavigationExtras): Promise<boolean> {
    const normalizedParams = commands
      .flatMap((v) => (typeof v === 'string' ? v.split('/') : v))
      .filter((v) => v != null && v !== '');

    const selectedOrgId = this.#orgStore.selectedEntityId();

    if (!selectedOrgId) {
      return this.#router.navigate([...normalizedParams], extras);
    }

    return this.#router.navigate(['/org', selectedOrgId, ...normalizedParams], extras);
  }
}
